import { useEffect, useState } from 'react';
import {
    collection,
    query,
    where,
    orderBy,
    onSnapshot,
    doc,
    getDoc
} from 'firebase/firestore';
import { firestore } from '../firebase.config';

const useClientNotifications = (user, refreshKeys = 0) => {
    const [notifications, setNotifications] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setRefreshKey(prev => prev + 1);
        }, 60000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (!user?.id || !user?.role) return;

        let isMounted = true; 

        let q = query(
            collection(firestore, 'adminNotifications'),
            where('toRole', '==', 'client'),
            orderBy('createdAt', 'desc')
        );

        if (user.role !== 'owner' && user.role !== 'support') {
            q = query(
                collection(firestore, 'adminNotifications'),
                where('toRole', '==', 'client'),
                where('sent', '==', true),
                orderBy('createdAt', 'desc')
            );
        }

        const unsubscribe = onSnapshot(q, async (snapshot) => {
            const now = Date.now();

            const notifs = await Promise.all(
                snapshot.docs.map(async (docSnap) => {
                    const data = docSnap.data();
                    const notifId = docSnap.id;

                    const readRef = doc(firestore, 'adminNotifications', notifId, 'reads', user.id);
                    const readSnap = await getDoc(readRef);

                    const readData = readSnap.exists()
                        ? readSnap.data()
                        : { isRead: false, readAt: null };

                    return {
                        id: notifId,
                        ...data,
                        readStatus: readData
                    };
                })
            );


            if (isMounted) {
                setNotifications(notifs);
                const unreadCount = notifs.filter(n => !n.readStatus?.isRead).length;
                console.log(`Available notifications: ${notifs.length}`);
                console.log(`Unread notifications: ${unreadCount}`);
            }
        });

        return () => {
            isMounted = false;
            unsubscribe();
        };
    }, [user, refreshKey, refreshKeys]);

    return notifications;
};

export default useClientNotifications;
